// Shared utilities for building export-friendly filenames

// Hyphenate and sanitize a display name for safe filenames
export const hyphenateNameForFile = (name: string, fallback = 'Export') =>
  (name && name.trim() ? name : fallback)
    // Replace invalid filename characters with a hyphen
    .replace(/[\\/:*?"<>|]+/g, '-')
    // Collapse whitespace into single hyphens
    .replace(/\s+/g, '-')
    // Collapse multiple hyphens
    .replace(/-+/g, '-')
    // Trim leading/trailing hyphens
    .replace(/^-+|-+$/g, '');

// Build a filename in the format: [<hyphenatedName>_]<Resource>_<Action>_<YYYY-MM-DD>.<ext>
export const buildExportFilename = (
  resource: string,
  action: string,
  options?: {
    name?: string; // optional display name to prefix
    date?: Date | string; // optional date (defaults to today)
    extension?: string; // defaults to 'csv'
  }
) => {
  const { name, date, extension = 'csv' } = options || {};

  const dateStr = typeof date === 'string'
    ? date
    : (date instanceof Date ? date : new Date()).toISOString().split('T')[0];

  // resource/action are expected to be constants, but sanitize just in case
  const sanitizeSegment = (s: string) => s.replace(/[\\/:*?"<>|]+/g, '').trim().replace(/\s+/g, '_');

  const namePrefix = name ? `${hyphenateNameForFile(name)}_` : '';
  const fileName = `${namePrefix}${sanitizeSegment(resource)}_${sanitizeSegment(action)}_${dateStr}.${extension}`;
  return fileName;
};
